export const isInApp = () => Boolean(globalThis.ReactNativeWebView);

/** Parsed payload of a message from the native app, or null if it isn't one. */
export function readAppMessage(event) {
  if (event.origin && event.origin !== window.location.origin) {
    return null;
  }
  if (typeof event.data !== "string") {
    return event.data ?? null;
  }
  try {
    return JSON.parse(event.data);
  } catch {
    return null;
  }
}

export function postMessageToApp(topic, message) {
  if (globalThis.ReactNativeWebView) {
    globalThis.ReactNativeWebView.postMessage(
      JSON.stringify({ topic, message }),
    );
  }
}

/**
 * Sends a file URL to the native app for download.
 * Uses the { topic, url } shape expected by the native DownloadFile handler
 * (distinct from postMessageToApp's { topic, message } shape).
 * Returns true when running inside the mobile WebView so callers can
 * skip the browser-only blob download path.
 */
export function downloadFileInApp(url) {
  if (globalThis.ReactNativeWebView) {
    globalThis.ReactNativeWebView.postMessage(
      JSON.stringify({ topic: "DownloadFile", url }),
    );
    return true;
  }
  return false;
}
